import { createSlice } from '@reduxjs/toolkit'
import extraReducers from './extraReducers'
const initialState = {
	STATUS: 'LOADING', // LOADING SUCCESS ERROR SERVER_ERROR
	singleSidedTypes: [],
	singleSidedTypesStatus: 'LOADING',
	user: null, // any
	userStatus: null,
	userStatusStatus: 'LOADING',
}
export const user = createSlice({
	extraReducers,
	initialState,
	name: 'user',
	reducers: {
		authorization(state, { payload }) {
			state.STATUS = payload?.STATUS
			state.user = payload?.user
		},
		resetUser() {
			return { ...initialState, STATUS: 'ERROR' }
		},
		updateUser(state, { payload }) {
			state.user = payload
		},
	},
})
export const { authorization, resetUser, updateUser } = user.actions
export default user.reducer
